import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function CheckoutFail() {
  const navigate = useNavigate();

  return (
    <div className="kn-page min-h-screen bg-knapp-surface flex items-center justify-center py-8">
      <div className="max-w-md mx-auto px-4">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="flex justify-center mb-6">
            <XCircle className="h-16 w-16 text-knapp-accent" />
          </div>

          <h1 className="kn-h1 mb-4">Zahlung abgebrochen</h1>

          <p className="kn-body mb-6">
            Die Zahlung wurde nicht abgeschlossen. Sie können es erneut
            versuchen.
          </p>

          <div className="space-y-3">
            <button
              onClick={() => navigate("/warenkorb")}
              className="kn-btn-primary w-full"
            >
              Zurück zum Warenkorb
            </button>
            <button
              onClick={() => navigate("/")}
              className="kn-btn-ghost w-full"
            >
              Zurück zum Shop
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
